import { c as _c } from "react/compiler-runtime";
import { STATES } from '@onefootprint/core';
import { Table, type TableRow } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useMobileLayout from '@/hooks/use-mobile-layout';
import Subsection from '../../../../../subsection';
import type { BusinessInsightDisplayOptions } from '../../../../onboarding-business-insight';
import type { FormattedRegistration } from '../../../../onboarding-business-insight.types';
import DrawerFilter from './components/drawer-filter';
import MobileRow from './components/mobile-row';
import Row from './components/row';
import useSOSFilingStatesQueryParams from './hooks/use-sos-filings-states-query-params';
type SOSFilingsProps = {
  data: FormattedRegistration[];
  onClick: (registrationId: string) => void;
  displayOptions?: BusinessInsightDisplayOptions;
};
const SOSFilings = t0 => {
  const $ = _c(35);
  const {
    data,
    onClick,
    displayOptions
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.registrations"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const queryParams = useSOSFilingStatesQueryParams();
  const isMobile = useMobileLayout();
  const {
    values
  } = queryParams;
  let t2;
  if ($[1] !== data || $[2] !== values.filingsStates) {
    t2 = values.filingsStates.length ? data.filter(t3 => {
      const {
        state
      } = t3;
      return state && values.filingsStates.includes(state);
    }) : data;
    $[1] = data;
    $[2] = values.filingsStates;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const filteredData = t2;
  let t3;
  if ($[4] !== data) {
    t3 = new Set(data.map(_temp).filter(_temp2));
    $[4] = data;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = [...t3];
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const stateFilterOptions = t4;
  let t5;
  if ($[8] !== isMobile || $[9] !== t) {
    t5 = isMobile ? [{
      text: t(_temp3)
    }] : [{
      text: t(_temp4),
      width: "33%"
    }, {
      text: t(_temp5),
      width: "33%"
    }, {
      text: t(_temp6),
      width: "33%"
    }];
    $[8] = isMobile;
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const columns = t5;
  let t6;
  if ($[11] !== isMobile) {
    t6 = t7 => {
      const {
        item
      } = t7;
      return isMobile ? <MobileRow filing={item} /> : <Row filing={item} />;
    };
    $[11] = isMobile;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const renderTr = t6;
  let t7;
  if ($[13] !== displayOptions?.hideFilters || $[14] !== queryParams.isReady || $[15] !== stateFilterOptions) {
    t7 = !displayOptions?.hideFilters && queryParams.isReady && <DrawerFilter states={stateFilterOptions} />;
    $[13] = displayOptions?.hideFilters;
    $[14] = queryParams.isReady;
    $[15] = stateFilterOptions;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t(_temp7);
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t) {
    t9 = t(_temp8);
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== onClick) {
    t10 = filing_0 => onClick(filing_0.id);
    $[21] = onClick;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const t11 = displayOptions?.tableVariant;
  let t12;
  if ($[23] !== columns || $[24] !== filteredData || $[25] !== isMobile || $[26] !== renderTr || $[27] !== t10 || $[28] !== t11 || $[29] !== t8 || $[30] !== t9) {
    t12 = <Table aria-label={t8} columns={columns} emptyStateText={t9} getKeyForRow={_temp9} hideThead={isMobile} items={filteredData} onRowClick={t10} renderTr={renderTr} variant={t11} />;
    $[23] = columns;
    $[24] = filteredData;
    $[25] = isMobile;
    $[26] = renderTr;
    $[27] = t10;
    $[28] = t11;
    $[29] = t8;
    $[30] = t9;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t12 || $[33] !== t7) {
    t13 = <Subsection><div className="flex flex-col gap-3">{t7}{t12}</div></Subsection>;
    $[32] = t12;
    $[33] = t7;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  return t13;
};
export default SOSFilings;
function _temp(t0) {
  const {
    state: state_0
  } = t0;
  return state_0;
}
function _temp2(state_1) {
  const isStateValid = Boolean(STATES.find(s => s.label === state_1));
  return isStateValid;
}
function _temp3($) {
  return $.table.header.state;
}
function _temp4($_0) {
  return $_0.table.header.state;
}
function _temp5($_1) {
  return $_1.table.header.fileDate;
}
function _temp6($_2) {
  return $_2.table.header.status;
}
function _temp7($_3) {
  return $_3.table.ariaLabel;
}
function _temp8($_4) {
  return $_4.table.emptyState;
}
function _temp9(filing) {
  return filing.id;
}